import { ApiServiceV1 } from '@services/api.service';

export default {
  async getBoxTypes({
    suffix, boxType = null, shipping = null,
    pageNum = 1, pageSize = 10,
  }) {
    const { data } = await ApiServiceV1.get(`${suffix}/box-type`, {
      params: {
        boxType, shipping, pageNum, pageSize,
      },
    });
    return data || {};
  },
  createBoxType({ suffix, data }) {
    return ApiServiceV1.post(`${suffix}/box-type`, data);
  },
  updateBoxType({ suffix, name, data }) {
    return ApiServiceV1.post(`${suffix}/box-type/${encodeURIComponent(name)}`, data);
  },
};
